<template>
    <div class="login-wrapper">
        <div class="col-lg-8 offset-lg-2">
            <div class="container">
                <div class="box"></div>
                <div class="container-forms">
                    <!--<div class="container-info">-->

                    <!--<div class="info-item">-->
                    <!--<div class="table">-->
                    <!--<div class="table-cell">-->
                    <!--<h4 class="text-center mb-4 text-white">ورود با نام کاربری و پسورد</h4>-->
                    <!--<button class="btn" @click="swipeLoginForm">-->
                    <!--ورود-->
                    <!--</button>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="info-item">-->
                    <!--<div class="table">-->
                    <!--<div class="table-cell">-->
                    <!--<h4 class="text-center mb-4 text-white">ورود به روش دریافت پیامک</h4>-->
                    <!--<button class="btn" @click="swipeLoginForm">-->
                    <!--ورود-->
                    <!--</button>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <div class="container-form">
                        <!--<div class="form-item sign-up">-->
                        <!--<div class="table">-->
                        <!--<div class="table-cell">-->
                        <!--<div v-if="!smsSended">-->
                        <!--<h5>لطفا شماره موبایل خود را وارد کنید</h5>-->
                        <!--<input class="form-control round" name="MobileNo" type="text"-->
                        <!--placeholder="شماره موبایل" v-model="loginModel.mobile"-->
                        <!--/>-->

                        <!--</div>-->
                        <!--<div v-if="smsSended">-->
                        <!--<h5>لطفا کد ارسال شده را وارد کنید</h5>-->
                        <!--<input class="form-control round" name="MobileNo" type="text"-->
                        <!--placeholder="کد تائید" v-model="loginModel.passwordHash"/>-->
                        <!--</div>-->
                        <!--<button class="btn btn-primary" @click="swipeSignUpForm(false)">-->
                        <!--ورود-->
                        <!--</button>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <div class="form-item  log-insign-up">
                            <div class="table">
                                <div class="table-cell">
                                    <div>
                                        <h5>لطفا نام کاربری و پسورد خود را وارد کنید</h5>
                                        <input class="form-control round" name="Username" type="text"
                                               placeholder="نام کاربری" v-model="loginModel.userName"
                                               @keypress.enter="swipeSignUpForm(true)"/>
                                        <input class="form-control round" name="Password" type="password"
                                               placeholder="پسورد" v-model="loginModel.passwordHash"
                                               @keypress.enter="swipeSignUpForm(true)"/>
                                    </div>
                                    <button class="btn btn-primary" @click="swipeSignUpForm(true)">
                                        ورود
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <transition
                    mode="out-in"
                    name="fade-long">
                <preloader v-if="isLoading"/>
            </transition>

        </div>
    </div>
</template>

<script>
    import * as $ from "jquery";
    import Utils from "../_framework/utils/Utils";
    import BaseService from "../_framework/api/BaseService";
    import EventBus from '../_framework/event-bus.js';


    export default {

        data() {
            return {
                userModel: {
                    mobile: null,
                    userName: null,
                    passwordHash: null
                },
                loginModel: {
                    mobile: "",
                    userName: "",
                    passwordHash: ""
                },
                isLoading: false,
                loginWithMobileNo: false,
                mobileNumber: "",
                confirmNumber: "",
                loginByMobileText: "ورود با موبایل",
                passwordHash: "",
                smsSended: false,

            }
        },
        mounted() {
            localStorage.removeItem('userName');
            localStorage.removeItem("mobile");
            localStorage.removeItem('token');
            localStorage.removeItem('userId');

            localStorage.setItem("userName", null);
            localStorage.setItem("token", null);
            if (this.$route.query.unauthorized) {
                this.$noty.error('لطفا ابتدا وارد حساب کاربری خود شوید!');
            }
            $("body").addClass("login");
        },
        methods: {
            swipeLoginForm() {
                // console.log("asdasd")
                $(".container").toggleClass("log-in");
                /*$(".info-item .btn").click(function(){

                });*/
            },
            swipeSignUpForm(bool) {
                if (!bool) {
                    if (this.smsSended) {

                        new BaseService("Login", "/ConfirmSmsCode").create(this.loginModel).then(response => {
                            // console.log(response.data);
                            this.isLoading = false;
                            const userName = response.data.data.userdata.fullName;
                            // const mobile = response.data.data.userdata.mobile;
                            const userId = response.data.data.userdata.id;
                            if (response.data.data.userdata.userImage !== "") {
                                EventBus.$emit("setProfileImage",
                                    // this.validateProfilePlaceholder(this.validateImageUrl(this.validateProfileImage(response.data.data.userdata.userImage))));
                                    this.validateImageUrl(response.data.data.userdata.userImage));
                            }
                            // if (response.data.data.userdata.userImage !== "") {
                            //     EventBus.$emit("setProfileImage",
                            //         // this.validateProfilePlaceholder(this.validateImageUrl(this.validateProfileImage(response.data.data.userdata.userImage))));
                            //         this.validateImageUrl(response.data.data.userdata.userImage));
                            // }
                            // if (response.data.data.userRole.indexOf("SuperAdmin") !== -1) {
                            //     localStorage.setItem("role", "admin");
                            // } else {
                            localStorage.setItem("role", "user");
                            // }
                            EventBus.$emit('userName', userName);
                            if (response.data.data.token) {
                                localStorage.setItem("token", response.data.data.token);
                                localStorage.setItem("userName", userName);
                                // localStorage.setItem("mobile", mobile);
                                localStorage.setItem("userId", userId)
                            } else {
                                this.$noty.error("کاربر شناسایی نشد");
                            }
                            this.$noty.success('ورود با موفقیت انجام شد', {timeout: 1000});
                            if (response.data.data.userRole[0] === "SuperAdmin") {
                                this.$router.push({name: 'mainItems'});
                            } else {
                                this.$router.push({name: 'editItem'});
                            }
                            this.userModel.userName = null;
                            this.userModel.passwordHash = null;
                            this.smsSended = false;
                        }).catch(error => {
                            this.isLoading = false;
                            $(".container").removeClass("active");
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    } else {

                        new BaseService("Login", "/SendSmsCode").create(this.loginModel).then(response => {
                            // console.log(response.data);
                            this.smsSended = true;
                            this.$noty.success('کد ارسال شده را وارد کنید', {timeout: 1000});
                        }).catch(error => {
                            this.isLoading = false;
                            $(".container").removeClass("active");
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }

                } else {
                    // Login
                    //$(".container").addClass("active");
                    // console.log(this.userModel)
                    this.isLoading = true;
                    new BaseService("Login", "/LoginWithUsername").create(this.loginModel).then(response => {
                        // console.log(response.data);
                        this.isLoading = false;
                        const userName = response.data.data.userdata.fullName;
                        // const mobile = response.data.data.userdata.mobile;
                        const userId = response.data.data.userdata.id;
                        if (response.data.data.userdata.userImage !== "") {
                            EventBus.$emit("setProfileImage",
                                // this.validateProfilePlaceholder(this.validateImageUrl(this.validateProfileImage(response.data.data.userdata.userImage))));
                                this.validateImageUrl(response.data.data.userdata.userImage));
                        }

                        // if (response.data.data.userRole[0] === "SuperAdmin") {
                        //     localStorage.setItem("role", "admin");
                        // } else {
                        //     localStorage.setItem("role", "user");
                        // }
                        localStorage.setItem("role", response.data.data.userdata.enRole);
                        // console.log(response.data.data.userdata.enRole);
                        EventBus.$emit('userName', userName);
                        if (response.data.data.token) {
                            localStorage.setItem("token", response.data.data.token);
                            localStorage.setItem("userName", userName);
                            // localStorage.setItem("mobile", mobile);
                            localStorage.setItem("userId", userId);
                            localStorage.setItem("setProfileImage", this.validateImageUrl(response.data.data.userdata.userImage));
                            // console.log(this.validateImageUrl(response.data.data.userdata.userImage));
                        } else {
                            this.$noty.error("کاربر شناسایی نشد");
                        }
                        this.$noty.success('ورود با موفقیت انجام شد', {timeout: 1000});
                        // if (response.data.data.userRole[0] === "SuperAdmin") {
                        //     this.$router.push({name: 'mainItems'});
                        // } else {
                        this.$router.push({name: 'home'});
                        // }
                        this.userModel.userName = null;
                        this.userModel.passwordHash = null;
                        this.smsSended = false;
                    }).catch(error => {
                        this.isLoading = false;
                        $(".container").removeClass("active");
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }

                /*$(".container-form .btn").click(function(){

                });*/
            }

        },
        beforeRouteLeave(to, from, next) {
            $("body").removeClass("login");
            next()
        }
    }
</script>

<style lang="scss" scoped>
    .form-control {
        display: block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057 !important;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 3rem;
        -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    }

    .form-control:focus {
        border-color: #ced4da;
        border-width: 1px;
        background-color: #ffffff;
        box-shadow: 0 0 15px -5px rgba(0, 0, 0, 0.25);
    }
</style>
